<!--Title Section-->
<br>
<app-title-jumbo title="Register" comment="Register and get access to Factor Investing tools"></app-title-jumbo>

<div class="container">

  <div class="row"><div class="offset-2 col-8">
    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-6">
          <div class="md-form">
            <input mdbInput type="text" id="firstname" class="form-control" formControlName="firstname">
            <label for="firstname">First Name</label>
            <mdb-error *ngIf="registerForm.get('firstname').invalid">This field is required.</mdb-error>
          </div>
        </div>
        <div class="col-md-6">
          <div class="md-form">
            <input mdbInput type="text" id="lastname" class="form-control" formControlName="lastname">
            <label for="lastname">Last Name</label>
            <mdb-error *ngIf="registerForm.get('lastname').invalid">This field is required.</mdb-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="md-form">
            <input mdbInput type="text" id="position" class="form-control" formControlName="position">
            <label for="position">Title</label>
            <mdb-error *ngIf="registerForm.get('position').invalid">This field is required.</mdb-error>
          </div>
        </div>
        <div class="col-md-8">
          <div class="md-form">
            <input mdbInput type="text" id="company" class="form-control" formControlName="company">
            <label for="company">Company</label>
            <mdb-error *ngIf="registerForm.get('company').invalid">This field is required.</mdb-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="md-form">
            <input mdbInput type="text" id="address" class="form-control" formControlName="address">
            <label for="address">Address</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="md-form">
            <input mdbInput type="text" id="postalCode" class="form-control" formControlName="postalCode">
            <label for="postalCode">Postal Code</label>
          </div>
        </div>
        <div class="col-md-5">
          <div class="md-form">
            <input mdbInput type="text" id="city" class="form-control" formControlName="city">
            <label for="city">City</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="md-form">
            <input mdbInput type="text" id="country" class="form-control" formControlName="country">
            <label for="country">Country</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="md-form">
            <input mdbInput type="text" id="username" class="form-control" formControlName="username">
            <label for="username">Username</label>
            <mdb-error *ngIf="registerForm.get('username').invalid">This field is required.</mdb-error>
          </div>
        </div>
        <div class="col-md-8">
          <div class="md-form">
            <input mdbInput type="email" id="email" class="form-control" formControlName="email">
            <label for="email">Email</label>
            <mdb-error *ngIf="registerForm.get('email').invalid">This field is required.</mdb-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="md-form">
            <input mdbInput type="password" id="password" class="form-control" formControlName="password">
            <label for="password">Password</label>
            <mdb-error *ngIf="registerForm.get('password').invalid">This field is required.</mdb-error>
          </div>
        </div>
        <div class="col-md-6">
          <div class="md-form">
            <input mdbInput type="password" id="cpassword" class="form-control" formControlName="cpassword">
            <label for="cpassword">Confirm Password</label>
            <mdb-error *ngIf="registerForm.get('cpassword').invalid">This field is required.</mdb-error>
          </div>
        </div>
      </div>
      <div class="text-center">
        <app-button btype="submit" [disabled]="registerForm.invalid">Register</app-button>
      </div>
      <div class="clearfix"></div>
    </form>
  </div></div>

</div>

<!-- Footer -->
<footer class="page-footer">

  <!-- Copyright -->
  <div class="text-center">
    <p style="color: slategrey">© 2020 Copyright: <strong>www.factor-based-investing.com</strong></p>
  </div>
  <!-- Copyright -->

</footer>
<!-- Footer -->
